import React from 'react';
import './Disclaimer.scss';

export const Disclaimer = ({ node }) => {
    return (
        <section
            className="paragraph__disclaimer kite-container"
            dangerouslySetInnerHTML={{
                __html: node.field_text_content?.value,
            }}
        ></section>
    );
};
